/**
 * CommonModal - a fully reusable modal component.
 * Props:
 * - show: boolean (modal visibility)
 * - onClose: () => void (close handler)
 * - title?: string | React.ReactNode (modal title)
 * - icon?: string | React.ReactNode (optional icon or element)
 * - children: React.ReactNode (modal body/content)
 * - actions?: React.ReactNode (custom buttons/footer)
 * - className?: string (optional extra class)
 * - ...rest: any other Modal props
 */
import React from "react";
import { Modal } from "react-bootstrap";

export interface CommonModalProps {
  show: boolean;
  onClose: () => void;
  title?: string | React.ReactNode;
  icon?: string | React.ReactNode;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  [key: string]: any;
}

const CommonModal = ({
  show,
  onClose,
  title,
  icon,
  children,
  actions,
  className = "",
  ...rest
}: CommonModalProps): JSX.Element => (
  <Modal
    centered
    show={show}
    onHide={onClose}
    backdrop="static"
    keyboard={false}
    className={className}
    {...rest}
  >
    <Modal.Body className="text-center mt-3 mb-3">
      {icon && <div className="modal-icon-box">{icon}</div>}
      {title && <h3 className="mb-3">{title}</h3>}
      <div className="mb-4">{children}</div>
      {actions}
    </Modal.Body>
  </Modal>
);

export default CommonModal; 